<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div *ngIf="isShow" class="progress-modal">
    <div class="progress-modal__bg stretch-to-parent"></div>
    <div
            [ngClass]="{ 'modal-lg': windowModel.commandName === progressWindowModel.MULTIPLE_DESIGN }"
            class="progress-modal__dialog modal-dialog"
    >
        <div class="modal-content">
            <div class="modal-header pt-2 pb-2">
                <h5 id="exampleModalLabel">{{ windowTitle }}</h5>
                <button (click)="close()" windeClose>
                    <sui-svg-icon icon="cross"/>
                </button>
            </div>

            <div class="modal-body">
                <div
                        *ngIf="
                        windowModel.progress && (windowModel.progress.percent || windowModel.progress.percent === 0);
                        else progressAnimation
                    "
                >
                    <div *ngIf="!windowModel.isCommandFinished()">
                        <h6>
                            {{ windowModel.progress.stepName ? windowModel.progress.stepName : 'Progress' }}
                            - {{ windowModel.progress.percent | number: '1.0-2' }}
                            %
                        </h6>
                        <div class="progress">
                            <div
                                    [attr.aria-valuenow]="windowModel.progress.percent"
                                    [ngStyle]="{ width: windowModel.progress.percent + '%' }"
                                    aria-valuemax="100"
                                    aria-valuemin="0"
                                    class="progress-bar progress-bar-striped"
                            ></div>
                        </div>
                    </div>

                    <div *ngIf="windowModel.progress.designIterationsChartData" class="position-relative clr">
                        <winde-design-data-chart
                                (iterationClick)="selectIteration($event)"
                                (iterationHover)="iterationHover($event)"
                                [chartData]="windowModel.progress.designIterationsChartData"
                                [selectedIteration]="selectedDesignIteration"
                        >
                        </winde-design-data-chart>

                        <div class="row info-row">
                            <div class="current-design col-6">
                                <div *ngIf="selectedDesignIteration >= 0 && currentDesignValues">
                                    <strong>Current iteration:</strong> {{ currentDesignValues['id'] + 1 }}
                                    <ul class="list-unstyled">
                                        <li>
                                            <strong class="d-inline-block align-middle">Cost:</strong>
                                            <winde-single-price-show
                                                    [currency]="currencyCode"
                                                    [price]="currentDesignValues['cost']"
                                                    class="d-inline-block align-middle"
                                            ></winde-single-price-show>
                                        </li>
                                        <li><strong>Limitations:</strong> {{ currentDesignValues['frequency'].toFixed(2) }}</li>
                                    </ul>
                                </div>
                            </div>

                            <div class="current-design col-6">
                                <div *ngIf="hoverIteration">
                                    <strong>Hover iteration:</strong> {{ hoverIteration.id + 1 }}
                                    <ul class="list-unstyled">
                                        <li>
                                            <strong class="d-inline-block align-middle">Cost:</strong>
                                            <winde-single-price-show
                                                    [currency]="currencyCode"
                                                    [price]="hoverIteration.cost"
                                                    class="d-inline-block align-middle"
                                            ></winde-single-price-show>
                                        </li>
                                        <li><strong>Limitations:</strong> {{ hoverIteration.frequency.toFixed(2) }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ng-template #progressAnimation>
                    <div class="progress-modal__processing">
                        <span class="d-inline-block mr-2">Processing...</span>
                    </div>
                </ng-template>
            </div>

            <div *ngIf="!windowModel.isCommandFinished()" class="modal-footer pt-2 pb-2">
                <button (click)="closeProject()" *ngIf="showCloseProjectBtn" windeTransparent>
                    {{ 'project.closeProject' | translate }}
                </button>
                <button (click)="cancelCurrentOperation()" windeRed>
                    <sui-svg-icon icon="cross"/>
                    {{ 'entity.action.cancel' | translate }}
                </button>
            </div>
        </div>

        <div *ngIf="preloaderText" class="progress-modal__preloader stretch-to-parent">
            <span class="mr-4">{{ preloaderText }}</span>
        </div>
    </div>
</div>
